import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAudiomackComponent } from './simple-icons-audiomack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAudiomackComponent ],
    exports:      [ SimpleIconsAudiomackComponent ],
    bootstrap:    []
})
export class SimpleIconsAudiomackModule {}
